export default "__VITE_PUBLIC_ASSET__ae334044__"